import App from '@/models/App'

import ProfileMe from '@/models/ProfileMe'

export default class ChatMember extends App {
    static get entity() {
        return 'ChatMembers'
    }
    static fields() {
        return {
            id: this.attr(''),
            chatRoomId: this.attr(''),
            userId: this.attr(''),
            role: this.attr(''),
            isApproval: this.attr(''),
            isDeleted: this.attr(''),
            profile: this.belongsTo(ProfileMe, 'userId'),
        }
    }
    static apiConfig = {
        actions: {
            update(chatRoomId, chatMemberId, params) {
                return this.patch(
                    `${chatRoomId}/chats/members/${chatMemberId}`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.overallURL(),
                    }
                )
            },
            destroy(chatRoomId, chatMemberId) {
                return this.delete(
                    `${chatRoomId}/chats/members/${chatMemberId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: 'data',
                        baseURL: App.overallURL(),
                    }
                )
            },
        },
    }
}
